import { Collapse } from "@material-ui/core";
import React from "react";
import FetchData from "../../../shared/fetchData";
import { updateObject } from "../../../shared/utility";
import Button from "../../UI/Button/Button";
import ContentForm from "../../UI/ContentForm/ContentForm";
import Input from "../../UI/Input/Input";
import Map from "../../UI/Map/Map";
import "../Bunch.css";
import Kiosks from "./Kiosks";
import SelectBox from "../../UI/Select/Select";

const BunchForm = (props) => {
  const [lat, setLat] = React.useState(35.7575);
  const [lon, setLon] = React.useState(51.4099);
  const [zoom, setZoom] = React.useState(14);
  const [edit, setEdit] = React.useState(false);
  const [rerender, setRerender] = React.useState(false);
  const [showDetails, setShowDetails] = React.useState(false);
  const [id, setId] = React.useState("");
  const [kiosks, setKiosks] = React.useState([]);
  const [selectedKiosks, setSelectedKiosks] = React.useState([]);
  const [kiosk, setKiosk] = React.useState("");
  const [proviances, setProviances] = React.useState([]);
  const [geoNames, setGeoNames] = React.useState([]);
  const [proviance, setProviance] = React.useState("");
  const [geoName, setGeoName] = React.useState("");
  const [invalidSelect, setInvalidSelect] = React.useState(false);
  const [bunch, setBunch] = React.useState({
    description: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    address: {
      elementType: "input",
      elementConfig: {
        type: "textarea",
        placeholder: "آدرس",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    addressEn: {
      elementType: "input",
      elementConfig: {
        type: "textarea",
        placeholder: "آدرس انگلیسی",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
  });

  React.useEffect(() => {
    var info = {
      geoName: {
        type: "PRV",
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/geonames/getGeoNames";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((resultPrv) => {
        setProviances(resultPrv.geoNames);
        var raw = JSON.stringify({ pl: "1000", pn: "1", version: "mtpx001" });
        var url = "management/api/v1/kiosks/getFinalizedKiosks";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setKiosks(result.kiosks);
          })
          .catch((error) => console.log(""));
        if (props.edit == true) {
          const item = bunch;
          const prv = resultPrv.geoNames?.filter(
            (g) => g.id === props.bunch.city?.parentId
          );
          if (!!prv && prv.length > 0) {
            setProviance({ value: prv[0].id, label: prv[0].description });

            var info = {
              geoName: {
                type: "CTY",
                parentId: prv[0].id,
              },
              pl: 1000,
              pn: 1,
              version: "mtpx001",
            };
            var raw = JSON.stringify(info);
            var url = "management/api/v1/geonames/getGeoNames";
            FetchData(raw, url)
              .then((response) => response.json())
              .then((resultGeo) => {
                setGeoNames(resultGeo.geoNames);
                const geo = resultGeo.geoNames?.filter(
                  (g) => g.id === props.bunch.city?.id
                );
                setGeoName({ value: geo[0].id, label: geo[0].description });
              })
              .catch((error) => console.log(error));
          }
          item.description.value = props.bunch.description;
          item.address.value = props.bunch.address;
          item.addressEn.value = props.bunch.addressEn;
          const ksks = props.bunch.kiosks;
          const slctd = selectedKiosks;
          ksks.map((k) => {
            slctd.push({
              id: k.id,
            });
          });
          setLat(props.bunch.lat);
          setLon(props.bunch.lon);
          setBunch(item);
          setEdit(true);
          setId(props.bunch.id);
        }
      })
      .catch((error) => console.log(error));
  }, [props.bunch]);

  const provianceChange = (value) => {
    setProviance(value);
    var info = {
      geoName: {
        type: "CTY",
        parentId: value?.value,
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/geonames/getGeoNames";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setGeoNames(result.geoNames);
      })
      .catch((error) => console.log(error));
  };
  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(bunch, {
      [controlName]: updateObject(bunch[controlName], {
        value: event.target.value,
        valid: true,
      }),
    });
    setBunch(updatedControls);
  };

  const changeMapHandler = (event) => {
    let lat = event.target.getCenter().lat;
    let lng = event.target.getCenter().lng;
    let zoom = event.target.getZoom();
    let ksk = bunch;
    setLat(lat);
    setLon(lng);
    setZoom(zoom);
    var addressRaw = JSON.stringify({ lat: lat, lon: lng, version: "mtpx001" });
    var addressUrl = "api/v1/geonames/getLatLonDesc";
    FetchData(addressRaw, addressUrl)
      .then((response) => response.json())
      .then((result) => {
        ksk.address.value = result.text;
        ksk.address.valid = true;
        setBunch(ksk);
        if (rerender) {
          setRerender(false);
        } else {
          setRerender(true);
        }
      });
  };

  const changeLocation = (lat, lng) => {
    let ksk = bunch;
    var addressRaw = JSON.stringify({ lat: lat, lon: lng, version: "mtpx001" });
    var addressUrl = "api/v1/geonames/getLatLonDesc";
    setLat(lat);
    setLon(lng);
    FetchData(addressRaw, addressUrl)
      .then((response) => response.json())
      .then((result) => {
        ksk.address.value = result.text;
        ksk.address.valid = true;
        setBunch(ksk);
        if (rerender) {
          setRerender(false);
        } else {
          setRerender(true);
        }
      });
  };

  const toggleFromDetails = (event, value) => {
    let valid = true;
    if (proviance == null || proviance == "") {
      valid = false;
      setInvalidSelect(true);
    }
    if (geoName == null || geoName == "") {
      valid = false;
      setInvalidSelect(true);
    }
    if (value == true) {
      const bnch = bunch;
      for (let key in bnch) {
        if (bnch[key].value == "") {
          bnch[key].valid = false;
          valid = false;
        }
      }
      if (valid) {
        setShowDetails(value);
      } else {
        setBunch(bnch);
        setRerender(!rerender);
      }
    } else {
      setShowDetails(value);
    }
  };
  const geoNameChange = (value) => {
    setLat(parseFloat(value.lat));
    setLon(parseFloat(value.lon));
    setGeoName(value);
  };

  let provianceList = [];
  if (proviances != null && proviances.length != 0) {
    let prvns = [...proviances];
    prvns.map((b) => {
      provianceList.push({
        value: b.id,
        label: b.description,
      });
    });
  }
  let geoNameList = [];
  if (geoNames != null && geoNames.length != 0) {
    let gnms = [...geoNames];
    gnms.map((b) => {
      geoNameList.push({
        value: b.id,
        lat: b.lat,
        lon: b.lon,
        label: b.description,
      });
    });
  }
  const formElementsArray = [];
  for (let key in bunch) {
    formElementsArray.push({
      id: key,
      config: bunch[key],
    });
  }

  const chooseKiosk = (event, kioskId) => {
    const hasKiosk = selectedKiosks.filter((k) => k.id === kioskId);
    if (!!hasKiosk && hasKiosk.length !== 0) {
      setSelectedKiosks(selectedKiosks.filter((k) => k.id !== kioskId));
      setRerender(!rerender);
    } else {
      const ksks = [...selectedKiosks];
      ksks.push({
        id: kioskId,
      });
      setSelectedKiosks(ksks);
      setRerender(!rerender);
    }
  };
  const insertBunch = (event) => {
    let valid = true;
    const bnch = bunch;
    for (let key in bnch) {
      if (bnch[key].value == "") {
        bnch[key].valid = false;
        valid = false;
      }
    }
    if (valid) {
      const info = {
        bunch: {
          id: edit ? id : "",
          description: bunch.description.value,
          address: bunch.address.value,
          addressEn: bunch.addressEn.value,
          lat: lat,
          lon: lon,
          city: { id: geoName?.value },
          kiosks: selectedKiosks,
        },
        version: "mtpx001",
      };
      var raw = JSON.stringify(info);
      var url = !edit
        ? "management/api/v1/bunches/insertBunch"
        : "management/api/v1/bunches/updateBunch";
      FetchData(raw, url)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "0") {
            props.toggleNewBunchFormAndReload(event, false);
          }
        });
    } else {
      setBunch(bnch);
      setRerender(!rerender);
    }
  };

  let form = formElementsArray.map((formElement) => {
    let col = "4 mt-2";
    if (formElement.config.elementConfig.type == "textarea") {
      col = formElement.id == "addressEn" ? "12 EN-input" : "12 mt-4";
    }
    if (formElement.id == "address") {
      return (
        <div className="ksk-form-map">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="row justify-content-center w-100 ml-0 mr-0">
                <SelectBox
                  name="form-field-name"
                  value={proviance}
                  placeholder="استان"
                  options={provianceList}
                  className={
                    invalidSelect && (proviance == null || proviance == "")
                      ? "invalid-select"
                      : ""
                  }
                  onChange={provianceChange}
                  col="6 mt-3"
                />
                <SelectBox
                  name="form-field-name"
                  value={geoName}
                  placeholder="شهر"
                  className={
                    invalidSelect && (geoName == null || geoName == "")
                      ? "invalid-select"
                      : ""
                  }
                  options={geoNameList}
                  onChange={geoNameChange}
                  col="6 mt-3"
                />
              </div>
              <Map
                cityId={"تهران"}
                lat={lat}
                lng={lon}
                zoom={zoom}
                latLngChangeHandler={changeMapHandler}
                changeLocation={changeLocation}
              />
            </div>
            <Input
              key={formElement.id}
              elementType={formElement.config.elementType}
              elementConfig={formElement.config.elementConfig}
              value={formElement.config.value}
              invalid={!formElement.config.valid}
              shouldValidate={formElement.config.validation}
              placeholder={formElement.config.placeholder}
              errorMessage={formElement.config.errorMessage}
              search={true}
              col={col}
              changed={(event) => inputChangedHandler(event, formElement.id)}
            />
          </div>
        </div>
      );
    } else {
      return (
        <Input
          key={formElement.id}
          elementType={formElement.config.elementType}
          elementConfig={formElement.config.elementConfig}
          value={formElement.config.value}
          invalid={!formElement.config.valid}
          shouldValidate={formElement.config.validation}
          placeholder={formElement.config.placeholder}
          errorMessage={formElement.config.errorMessage}
          search={true}
          col={col}
          changed={(event) => inputChangedHandler(event, formElement.id)}
        />
      );
    }
  });
  const ksks = kiosks.map((k) => {
    return (
      <Kiosks
        chooseKiosk={chooseKiosk}
        selectedKiosks={selectedKiosks}
        kiosk={k}
      />
    );
  });
  return (
    <>
      <Collapse in={!showDetails}>
        <div className="row justify-content-center">
          <div className="ksk-cntnr">
            <ContentForm headetText="اطلاعات خوشه">
              <div className="ksk-frm">{form}</div>
              <div className="col-12">
                <div className="row justify-content-center w-100 mt-3">
                  <div className="col-6 text-center">
                    <Button
                      btnType="Success"
                      clicked={(event) => toggleFromDetails(event, true)}
                    >
                      بعدی
                    </Button>
                  </div>
                  <div className="col-6 text-center">
                    <Button
                      btnType="General"
                      clicked={(event) =>
                        props.toggleNewBunchForm(event, false)
                      }
                    >
                      برگشت
                    </Button>
                  </div>
                </div>
              </div>
            </ContentForm>
          </div>
        </div>
      </Collapse>
      <Collapse in={showDetails}>
        <div className="row justify-content-center">
          <div className="ksk-cntnr">
            <ContentForm headetText="اطلاعات لاکرهای خوشه">
              {ksks}
              <div className="row justify-content-center w-100 mt-3">
                <div className="col-6 text-center">
                  <Button btnType="General" clicked={insertBunch}>
                    ثبت
                  </Button>
                </div>
                <div className="col-6 text-center">
                  <Button
                    btnType="Success"
                    clicked={(event) => toggleFromDetails(event, false)}
                  >
                    برگشت
                  </Button>
                </div>
              </div>
            </ContentForm>
          </div>
        </div>
      </Collapse>
    </>
  );
};

export default BunchForm;
